"use client";
import { components } from "@/slices";
import { SliceZone } from "@prismicio/react";
import React from "react";

export default function CFooter({ logo, slices, context }) {

  return (
    <footer className="w-full bg-bleu-950 contre-uno text-bleu-50">
      <div className="framing padding-x py-10">
        <SliceZone slices={slices} components={components} context={{ ...context, logo }} />
      </div>
    </footer>
  );
}
